import { InternalApiClient } from "@/services/internalAPI/InternalApiClient";
import { ContactUsForm, WorkWithUsForm } from "@/@types/FormData";



export const sendForm = async (formData: ContactUsForm | WorkWithUsForm | FormData) => {
  const client = InternalApiClient.getInstance(); 
  const response = await client.post(formData); 
  return response;
};
